import { AUDIENCE_GENDER } from '~/constants';

import { genderOptions } from './GenderTag.model';

export const getGenderFromValue = (value: string) => {
  const genderKey = Object.values(AUDIENCE_GENDER).find(
    (key) => genderOptions[key].value === value,
  );
  return genderKey
    ? genderOptions[genderKey]
    : { value: '', name: '', color: '' };
};
